import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store/index.js'
import iView from 'iview';


import 'iview/dist/styles/iview.css';
import '../src/styles/theme/index.less';
import './styles/index.css'

import './routerhook.js'
import VP from './directives/v-p.js'
Vue.directive('p',VP)
import ImgShow from './plugins/ImgShow/index'
Vue.use(ImgShow)




import TableList from "./components/TableList/index.vue";
Vue.component('TableList',TableList)

import SearchGroup from './components/SearchGroup/index.vue';
Vue.component('SearchGroup',SearchGroup)

import MultTab from "./components/MultTab/index.vue";
Vue.component('MultTab',MultTab)

// import {mixin} from './mixin/index.js'
// Vue.mixin(mixin)
// import {}
import {routergo} from './mixin/routergo.js'
Vue.mixin(routergo)


Vue.config.productionTip = false
Vue.use(iView);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
